
import { MenuItem } from '@/types/menu';

/**
 * Converts database snake_case properties to camelCase for frontend usage
 */
export function formatMenuItemFromDB(item: any): MenuItem {
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    price: item.price,
    menu_id: item.menu_id,
    category: item.category,
    allergens: item.allergens || [],
    image: item.image,
    has3dmodel: item.has3dmodel || false,
    // Make sure both model_url and modelurl are set
    model_url: item.modelurl || item.model_url,
    modelurl: item.modelurl || item.model_url,
    order_position: item.order_position || 0,
    is_happy_hour: item.is_happy_hour || false,
    happy_hour_start: item.is_happy_hour ? item.happy_hour_start : null,
    happy_hour_end: item.is_happy_hour ? item.happy_hour_end : null,
    happy_hour_price: item.happy_hour_price,
    out_of_stock: item.out_of_stock || false,
    is_daily_special: item.is_daily_special || false,
    is_cocktail: item.is_cocktail || false,
    created_at: item.created_at,
    updated_at: item.updated_at,
    hidden: item.hidden || false,
    translations: item.translations || {}
  };
}

/**
 * Helper function to parse JSON fields from Supabase
 */
export function parseJsonField<T>(field: any, defaultValue: T): T {
  if (!field) return defaultValue;
  try {
    return typeof field === 'string' ? JSON.parse(field) : field;
  } catch (e) {
    console.error(`Error parsing JSON field:`, e);
    return defaultValue;
  }
}

/**
 * Converts frontend camelCase properties to snake_case for database storage
 */
export function formatMenuItemForDB(item: Partial<MenuItem>) {
  // Ensure required fields are present
  if (!item.name || !item.description || item.price === undefined || !item.category) {
    throw new Error("Missing required fields for menu item");
  }
  
  return {
    menu_id: item.menu_id,
    name: item.name,
    description: item.description,
    price: item.price,
    category: item.category,
    allergens: item.allergens,
    image: item.image,
    has3dmodel: item.has3dmodel,
    modelurl: item.model_url || item.modelurl,
    order_position: item.order_position || 0,
    is_happy_hour: item.is_happy_hour || false,
    happy_hour_start: item.is_happy_hour ? item.happy_hour_start : null,
    happy_hour_end: item.is_happy_hour ? item.happy_hour_end : null,
    happy_hour_price: item.happy_hour_price,
    out_of_stock: item.out_of_stock || false,
    is_daily_special: item.is_daily_special || false,
    is_cocktail: item.is_cocktail || false,
    hidden: item.hidden || false
  };
}
